import { render } from "./svg-left-arrow.vue?vue&type=template&id=bb0632d2"
import script from "./svg-left-arrow.vue?vue&type=script&lang=ts"
export * from "./svg-left-arrow.vue?vue&type=script&lang=ts"
script.render = render

export default script